<template>
  <!-- O wrapper fica montado enquanto houver suporte, para que o modal aberto
       NUNCA seja destruído junto com o card (evita modal órfão/congelado). -->
  <div v-if="rootVisible">
    <div v-if="showCard" class="push-card">
      <div class="push-card__body">
        <h4>Quer saber da próxima vaga na hora?</h4>
        <p>
          A gente avisa neste aparelho assim que sair uma vaga com a sua cara.
          Você desliga quando quiser.
        </p>
      </div>

      <!-- Secundario primeiro, e os dois com metade da largura: sem borda no
           "Agora nao", metade do bloco sem contorno leria como espaco vazio
           em vez de botao. -->
      <div class="push-card__actions">
        <button class="push-card__later" @click="snooze">Agora não</button>
        <button class="push-card__cta" :style="{ background: brandColor }" @click="openModal">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
          </svg>
          {{ iosInstall ? 'Como ativar' : 'Quero ser avisado' }}
        </button>
      </div>
    </div>

    <!-- Modal explicativa (fora do v-if do card, para fechar sem ser destruído) -->
    <vs-popup
      class="push-modal"
      :title="iosInstall ? 'Ativar avisos no iPhone' : 'Ativar avisos de vaga'"
      :active.sync="modalActive"
    >
      <div class="push-modal__content">
        <p class="push-modal__lead">Os avisos aparecem na tela do aparelho, mesmo com a Recrutei fechada.</p>

        <!-- Duas secoes de proposito: hoje so existe o aviso de vaga nova, e
             listar os tres juntos prometeria o que ainda nao sai. Os outros dois
             ja existem por e-mail -- o que falta e a versao push deles.
             Icones desenhados aqui: emoji muda de peso optico a cada sistema. -->
        <p class="push-modal__group">O que voc&ecirc; vai receber</p>
        <ul class="push-modal__list" :style="{ '--push-icon-color': brandColor, '--push-icon-bg': brandColorSoft }">
          <li>
            <span class="push-modal__badge">
              <svg viewBox="0 0 16 16" aria-hidden="true">
                <circle cx="8" cy="8" r="6.25" fill="none" stroke="currentColor" stroke-width="1.5" />
                <circle cx="8" cy="8" r="2.5" fill="none" stroke="currentColor" stroke-width="1.5" />
              </svg>
            </span>
            Novas vagas que combinam com o seu perfil
          </li>
        </ul>

        <p class="push-modal__group">O que estamos preparando</p>
        <ul class="push-modal__list" :style="{ '--push-icon-color': brandColor, '--push-icon-bg': brandColorSoft }">
          <li>
            <span class="push-modal__badge">
              <svg viewBox="0 0 16 16" aria-hidden="true">
                <rect x="1.75" y="3.25" width="12.5" height="9.5" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.5" />
                <path d="M2.5 4.5 8 8.75l5.5-4.25" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            Convites de empresas para processos seletivos
          </li>
          <li>
            <span class="push-modal__badge">
              <svg viewBox="0 0 16 16" aria-hidden="true">
                <path d="M8 2.25a4 4 0 0 0-4 4v3l-1 1.5h10l-1-1.5v-3a4 4 0 0 0-4-4Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                <path d="M6.75 12.5a1.25 1.25 0 0 0 2.5 0" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
            </span>
            Atualiza&ccedil;&otilde;es das suas candidaturas
          </li>
        </ul>

        <!-- Caminho iOS: a permissão só pode ser pedida com o app na Tela de
             Início, então aqui a tela é outra, não a mesma com um aviso a mais. -->
        <div v-if="iosInstall" class="push-modal__ios">
          <p class="push-modal__ios-title">Antes, adicione a Recrutei à Tela de Início:</p>
          <IosInstallSteps :style="{ '--push-icon-color': brandColor, '--push-icon-bg': brandColorSoft }" />
        </div>

        <!-- Permissão bloqueada -->
        <div v-else-if="blocked" class="push-modal__blocked">
          <p>
            O navegador está com os avisos <b>bloqueados</b> para a Recrutei — por isso
            ele não pergunta de novo. Para liberar, toque no cadeado ao lado do endereço,
            procure por notificações e escolha permitir.
          </p>
        </div>

        <p v-else class="push-modal__hint">
          Vale só para este aparelho, e você desliga quando quiser em Configurações.
        </p>

        <div class="push-modal__actions">
          <button type="button" class="push-modal__later" @click="dismissModal">Agora não</button>
          <button
            v-if="!iosInstall && !blocked"
            type="button"
            class="push-modal__confirm"
            :style="{ background: brandColor }"
            :disabled="loading"
            @click="enable"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
            {{ loading ? 'Ativando...' : 'Ativar avisos' }}
          </button>
          <button
            v-else
            type="button"
            class="push-modal__confirm"
            :style="{ background: brandColor }"
            @click="closeModal"
          >
            Entendi
          </button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import webPush from '../../services/webPush'
import IosInstallSteps from './IosInstallSteps.vue'
import { clearPushOptOut, hasOptedOutOfPush, isPushInviteSnoozed, snoozePushInvite } from '../../utils/pushPreferences'

export default {
  name: 'EnablePushNotificationsCard',
  components: { IosInstallSteps },
  props: {
    // 'none' monta so o modal, sem desenhar o card: serve a quem ja tem o proprio
    // gatilho na tela e quer reaproveitar os estados e a ativacao daqui, chamando
    // openModal() por ref. Evita duplicar a logica num segundo componente.
    trigger: {
      type: String,
      default: 'card',
      validator: (value) => ['card', 'none'].includes(value),
    },
    // De onde saiu o convite. O mesmo componente e montado no fim da candidatura
    // e no gatilho permanente da lista de vagas; sem isto o funil nao responde
    // qual dos dois converte, que e a pergunta que interessa.
    source: {
      type: String,
      default: 'unknown',
    },
  },
  data() {
    return {
      // Quem hospeda o convite precisa distinguir "nao ha convite" de "ainda
      // estou descobrindo": o mounted e assincrono (consulta o servidor), e
      // quem decidir antes disso decide sobre um estado que ainda nao existe.
      resolved: false,
      supported: false,
      iosInstall: false,
      subscribed: false,
      snoozed: false,
      optedOut: false,
      blocked: false,
      loading: false,
      modalActive: false,
      inviteShownTracked: false,
    }
  },
  watch: {
    // Quem hospeda o convite precisa saber se ele está de fato na tela: o popup
    // de candidatura, por exemplo, só deixa de se fechar sozinho quando há
    // convite para ler. A decisão continua sendo daqui.
    showCard: {
      immediate: true,
      handler(visible) {
        this.$emit('visibility-change', visible)
      },
    },
    resolved: {
      immediate: true,
      handler(done) {
        this.$emit('resolved-change', done)
      },
    },
    canInvite: {
      immediate: true,
      handler(available) {
        this.$emit('can-invite-change', available)
      },
    },
    // O modal entra por cima de quem hospeda o card, com transição de 0,2s. Nesse
    // intervalo os dois aparecem juntos e o texto de um atravessa o do outro, então
    // o hospedeiro precisa saber a hora de sair da frente.
    modalActive(active) {
      this.$emit('modal-toggle', active)
    },
    // Impressao do convite. Uma so por montagem: o valor pode voltar a true
    // (ativar e depois desligar em outra aba, por exemplo) e cada ida e volta
    // contaria como um convite novo, inflando o denominador da conversao.
    inviteVisible: {
      immediate: true,
      handler(visible) {
        if (!visible || this.inviteShownTracked) return
        this.inviteShownTracked = true
        this.track('push_invite_shown')
      },
    },
  },
  computed: {
    // A cor vem da empresa dona do portal, nao da marca Recrutei: o convite vive
    // dentro da tela dela. Pelo getter oficial, para nao replicar o fallback que
    // ja esta copiado a mao em dezenas de componentes.
    ...mapGetters('company', { brandColor: 'color' }),
    // O disco do icone e a propria cor da empresa a 12%: assim o acabamento
    // acompanha o portal sem precisar de um segundo token por empresa.
    brandColorSoft() {
      const c = this.brandColor
      return /^#[0-9a-f]{6}$/i.test(c || '') ? `${c}1F` : 'rgba(21, 81, 177, 0.12)'
    },
    // Mantém o componente (e o modal) montado enquanto houver caminho de ativação.
    // Não depende de subscribed/dismissed, então ativar não destrói o modal aberto.
    rootVisible() {
      return this.supported || this.iosInstall
    },
    // Controla apenas a exibição do card de entrada.
    showCard() {
      if (this.trigger === 'none') return false
      // Quem desligou em Configuracoes nao e convidado de novo -- insistir com
      // quem ja disse nao e o que faz a pessoa bloquear o site. Ja quem so
      // recusou o convite volta a ve-lo depois do periodo de silencio.
      if (this.subscribed || this.snoozed || this.optedOut) return false
      return this.supported || this.iosInstall
    },
    // Vale a pena oferecer a ativacao? O gatilho externo usa isto para decidir se
    // aparece; o card usa o showCard, que soma a dispensa e o opt-out.
    canInvite() {
      if (this.subscribed) return false
      return this.supported || this.iosInstall
    },
    // O convite esta na tela? Em modo 'none' quem desenha o gatilho e o
    // hospedeiro, e ele usa exatamente o canInvite que emitimos -- entao e esse
    // o sinal de impressao ali, e nao o showCard, que nunca fica true.
    inviteVisible() {
      return this.trigger === 'none' ? this.canInvite : this.showCard
    },
  },
  async mounted() {
    try {
      this.snoozed = isPushInviteSnoozed()
      this.optedOut = hasOptedOutOfPush()
      this.supported = webPush.isSupported()
      this.iosInstall = webPush.iosNeedsInstall()
      this.blocked = webPush.permission() === 'denied'
      // Ja da para decidir sobre o card: o que falta consultar so pode tira-lo
      // da tela, nunca coloca-lo. Avisar aqui evita segurar quem hospeda.
      this.resolved = true
      if (this.supported) {
        // Cruza com o servidor: uma inscrição removida a partir de outro
        // aparelho deixa o endpoint vivo aqui, e o estado local sozinho diria
        // "ligado" para quem não recebe mais nada.
        this.subscribed = await webPush.syncSubscriptionState()
      }
    } catch (e) {
      // falha silenciosa: o card simplesmente não aparece -- mas quem hospeda
      // precisa saber que a decisao terminou, senao fica esperando para sempre.
      this.resolved = true
    }
  },
  methods: {
    // Tracking nunca pode derrubar o fluxo daqui: conceder a permissao e um
    // clique que so acontece uma vez, e uma excecao no meio o gastaria a toa.
    track(eventName, props = {}) {
      (async () => {
        try {
          const { trackEvent } = await import('@/services/posthog')
          trackEvent(eventName, {
            source: this.source,
            ios_pending_install: this.iosInstall,
            permission_blocked: this.blocked,
            ...props,
          })
        } catch (_) { /* posthog optional */ }
      })()
    },
    openModal() {
      this.blocked = webPush.permission() === 'denied'
      this.modalActive = true
      this.track('push_invite_opened')
    },
    // Ha duas instancias deste componente na mesma tela -- o convite do popup de
    // candidatura e o gatilho do bloco de oportunidades -- e elas nao se
    // enxergam. Quem hospeda avisa a outra quando uma ativa; senao o gatilho
    // segue na tela convidando para algo que ja esta ligado, e um clique nele
    // manda um POST repetido com o mesmo endpoint.
    markSubscribed() {
      this.subscribed = true
    },
    closeModal() {
      this.modalActive = false
    },
    // Recusar dentro do modal e o unico abandono do funil que nao deixa rastro
    // em outro evento: a pessoa leu a oferta inteira e desistiu ali. Nao vale
    // para o "Entendi" do iPhone, que fecha a mesma tela sem ter havido oferta.
    dismissModal() {
      this.track('push_modal_dismissed')
      this.closeModal()
    },
    // "Agora nao" nao e "nunca": silencia por umas horas, para quem se
    // candidata a varias vagas de uma vez nao ver o convite a cada uma.
    snooze() {
      this.snoozed = true
      snoozePushInvite()
      this.track('push_invite_snoozed')
      // Quem hospeda decide o que fazer: no popup de candidatura, responder ao
      // convite e a ultima coisa que restava ali, entao ele fecha.
      this.$emit('invite-answered', 'snoozed')
    },
    async enable() {
      this.loading = true
      try {
        await webPush.subscribe()
        // Ativar aqui apaga o opt-out, como em Configuracoes. Sem isto a marca
        // fica de pe: se a inscricao cair depois (endpoint rotacionado, ou o
        // aparelho removido de outro), o `showCard` continua falso para sempre e
        // o app nunca mais oferece religar.
        clearPushOptOut()
        this.optedOut = false
        this.modalActive = false
        this.subscribed = true
        this.track('push_notifications_enabled')
        this.$vs.notify({
          title: 'Avisos ativados!',
          text: 'Você será avisado neste aparelho sobre novas vagas e convites.',
          iconPack: 'feather',
          icon: 'icon-bell',
          color: 'success',
          position: 'top-right',
          time: 5000,
        })
        this.$emit('invite-answered', 'subscribed')
      } catch (e) {
        this.handleError(e)
      } finally {
        this.loading = false
      }
    },
    handleError(error) {
      const code = error && error.message
      const map = {
        DENIED: 'O navegador bloqueou os avisos. Libere pelo cadeado ao lado do endereço.',
        DISMISSED: 'Permissão não concedida. É só tentar de novo quando quiser.',
        UNSUPPORTED: 'Este navegador não suporta avisos.',
        NO_VAPID_KEY: 'Não foi possível iniciar os avisos agora. Tente mais tarde.',
      }
      if (code === 'DENIED') this.blocked = true
      // Eventos separados porque as consequencias sao opostas: negado nao
      // pergunta de novo neste aparelho, ignorado ainda pode voltar.
      if (code === 'DENIED') this.track('push_permission_denied')
      if (code === 'DISMISSED') this.track('push_permission_dismissed')
      this.$vs.notify({
        title: 'Não foi possível ativar',
        text: map[code] || 'Ocorreu um erro ao ativar os avisos. Tente novamente.',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'warning',
        position: 'top-right',
        time: 6000,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
// O convite e uma SECAO do popup, nao uma caixa dentro da caixa: a hierarquia
// vem do peso e do tamanho do texto, e nao de fundo colorido. Os tons sao os do
// design system da Recrutei -- nao troque por um cinza generico do Tailwind.
.push-card {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #ececec;

  &__body {
    h4 {
      margin: 0 0 4px;
      font-size: 16px;
      font-weight: 700;
      color: #333333;
    }

    p {
      margin: 0;
      font-size: 15px;
      line-height: 1.55;
      color: #4f4f4f;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
  }


  // Os dois em metade: `flex: 1 1 0` com `min-width: 0` divide igual mesmo
  // quando um rotulo e mais longo que o outro.
  &__later,
  &__cta {
    flex: 1 1 0;
    min-width: 0;
    padding: 13px 12px;
    font-family: inherit;
    font-size: 15px;
    // O rotulo primario cabe em uma linha por ~8px de folga na caixa de 460.
    // Sem isto ele quebra em duas e os dois botoes crescem juntos.
    white-space: nowrap;
    border-radius: 9999px;
    cursor: pointer;
  }

  &__later {
    font-weight: 400;
    color: #4f4f4f;
    background: transparent;
    border: 1px solid #d5d5d5;
    transition: background 0.15s ease;

    &:hover {
      background: #fafbfc;
    }
  }

  &__cta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;

    // Defensivo: o popup que hospeda este card tem uma regra de svg propria,
    // e ela ja esticou este sino para 57px uma vez.
    svg {
      flex-shrink: 0;
      width: 17px;
      height: 17px;
    }
    font-weight: 500;
    color: #fff;
    // A cor vem da empresa do portal: o app e white-label, e a acao primaria
    // daquela tela ja tem dono. Fundo definido inline, no template.
    border: 1px solid transparent;
    transition: filter 0.15s ease;

    &:hover {
      filter: brightness(0.94);
    }
  }

  // Celular: os botoes empilham, cada um em largura cheia, e a acao primaria
  // vem em cima. Por `order`, nao trocando o markup: no template a inversao
  // pegaria tambem o desktop e mudaria a ordem de tabulacao, que segue o DOM.
  @media (max-width: 576px) {
    &__cta {
      order: 1;
    }

    &__later {
      order: 2;
    }

    &__actions {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }
  }
}

.push-modal {
  &__content {
    font-size: 15px;
    line-height: 1.55;
    color: #4f4f4f;
  }

  &__lead {
    margin: 0;
  }

  // Subtitulo leve de proposito: ele separa dois grupos, nao compete com os
  // itens. Caixa alta e peso 700 aqui gritavam mais que o conteudo.
  &__group {
    margin: 16px 0 6px;
    font-size: 14px;
    font-weight: 500;
    color: #767676;

    &:first-of-type {
      margin-top: 16px;
    }
  }

  &__list {
    list-style: none;
    padding: 0;
    margin: 0;
    color: #333333;

    li {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 3px 0;
      line-height: 1.4;
    }
  }

  // Disco atras do icone: acabamento, nao hierarquia -- o que separa os dois
  // grupos e o subtitulo, entao os itens de ambos sao iguais.
  &__badge {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    border-radius: 9999px;
    background: var(--push-icon-bg, rgba(21, 81, 177, 0.12));
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 17px;
      height: 17px;
      color: var(--push-icon-color, #1551b1);
    }
  }

  &__hint {
    font-size: 14px;
    color: #767676;
  }

  // O passo a passo NAO vive numa caixa: dentro do modal ela vira moldura
  // dentro de moldura, e come a largura de uma tela que ja e estreita. Um
  // divisor separa tao bem quanto, e devolve o espaco ao conteudo.
  &__ios {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #ececec;

    &-title {
      margin: 0 0 14px;
      font-size: 15px;
      font-weight: 700;
      color: #333333;
    }
  }

  // O aviso de permissao bloqueada continua em caixa: ali o destaque e o
  // proprio recado, e sao poucas linhas.
  &__blocked {
    margin-top: 16px;
    padding: 14px 16px;
    background: #fafbfc;
    border: 1px solid #ececec;
    border-radius: 16px;
    font-size: 14px;
    line-height: 1.5;
    color: #4f4f4f;

    p {
      margin: 0;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 20px;
  }
  // Mesma gramatica do convite: metade cada, pilula, secundario primeiro.
  &__later,
  &__confirm {
    flex: 1 1 0;
    min-width: 0;
    padding: 13px 12px;
    font-family: inherit;
    font-size: 15px;
    white-space: nowrap;
    border-radius: 9999px;
    cursor: pointer;
  }

  &__later {
    color: #4f4f4f;
    background: transparent;
    border: 1px solid #d5d5d5;
    transition: background 0.15s ease;

    &:hover {
      background: #fafbfc;
    }
  }

  &__confirm {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-weight: 500;
    color: #fff;
    border: 1px solid transparent;
    transition: filter 0.15s ease;

    svg {
      flex-shrink: 0;
      width: 17px;
      height: 17px;
    }

    &:hover:not(:disabled) {
      filter: brightness(0.94);
    }

    &:disabled {
      opacity: 0.6;
      cursor: default;
    }
  }

  // Mesma regra do card, no mesmo ponto de quebra: empilha e a acao primaria
  // vem em cima. Lado a lado num celular, os dois botoes ficam estreitos
  // demais para o texto que carregam.
  @media (max-width: 576px) {
    &__actions {
      flex-direction: column;
      align-items: stretch;
      gap: 8px;
    }

    &__confirm {
      order: 1;
    }

    &__later {
      order: 2;
    }
  }
}

// O vs-popup desenha o proprio container e cabecalho, e eles nao seguiam nada
// do que ajustamos aqui dentro. `::v-deep` porque o estilo e escopado e o
// Vuesax renderiza essa marcacao fora do componente.
::v-deep .vs-popup {
  border-radius: 24px;
  overflow: hidden;

  .vs-popup--header {
    padding: 22px 28px 0;
  }

  .vs-popup--title h3 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.2;
    color: #333333;
  }

  // O X do Vuesax vem grande e colorido; aqui ele e utilitario.
  .vs-popup--close {
    background: transparent !important;
    box-shadow: none;
    color: #767676;
    transform: none;

    &:hover {
      color: #333333;
    }
  }

  .vs-popup--content {
    padding: 16px 28px 24px;
    margin: 0;
  }
}
</style>
